/**
 * @generated SignedSource<<550b70d2fe0a348e20cb3fa9aa14cbcf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type NftCmsExhibitionCaptionPosition = "left" | "right" | "%future added value";
export type NftCmsExhibitionFormat = "html" | "static" | "%future added value";
export type NftCmsExhibitionImageSize = "full" | "half" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type HeroBannerItem_heroBannerItemExhibition$data = {
  readonly bannerConfig: {
    readonly backgroundColor?: string | null;
    readonly burnIn?: string | null;
    readonly captionPosition?: NftCmsExhibitionCaptionPosition | null;
    readonly ctaCopy?: string | null;
    readonly ctaHref?: string | null;
    readonly imageSize?: NftCmsExhibitionImageSize | null;
    readonly " $fragmentSpreads": FragmentRefs<"HtmlBannerText_htmlBannerExhibition">;
  } | null;
  readonly desktopImage: {
    readonly height: string | null;
    readonly url: string | null;
    readonly width: string | null;
  } | null;
  readonly format: NftCmsExhibitionFormat | null;
  readonly mobileImage: {
    readonly height: string | null;
    readonly url: string | null;
    readonly width: string | null;
  } | null;
  readonly " $fragmentType": "HeroBannerItem_heroBannerItemExhibition";
};
export type HeroBannerItem_heroBannerItemExhibition$key = {
  readonly " $data"?: HeroBannerItem_heroBannerItemExhibition$data;
  readonly " $fragmentSpreads": FragmentRefs<"HeroBannerItem_heroBannerItemExhibition">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "height",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "width",
    "storageKey": null
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ctaCopy",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ctaHref",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HeroBannerItem_heroBannerItemExhibition",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "format",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NftCmsExhibitionImageType",
      "kind": "LinkedField",
      "name": "desktopImage",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NftCmsExhibitionImageType",
      "kind": "LinkedField",
      "name": "mobileImage",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "bannerConfig",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "burnIn",
              "storageKey": null
            },
            (v1/*: any*/),
            (v2/*: any*/)
          ],
          "type": "NftCmsExhibitionStaticBannerType",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "imageSize",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "captionPosition",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "backgroundColor",
              "storageKey": null
            },
            (v1/*: any*/),
            (v2/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "HtmlBannerText_htmlBannerExhibition"
            }
          ],
          "type": "NftCmsExhibitionHtmlBannerType",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NftCmsExhibitionHeroBannerType",
  "abstractKey": null
};
})();

(node as any).hash = "888b9895d5a2460c2d275d83de50c0d9";

export default node;
